import { Snackbar } from '@mui/material';

const BranchSnackbar = ({ open, setOpen, message }) => {

    const handleClose = (event, reason) => {
        if (reason === 'clickaway')
            return;
        setOpen(false);
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            message={message}
            key={{ vertical: 'bottom', horizontal: 'center' }}
        />
    );
};

export default BranchSnackbar;